import { useEffect, useState } from "react";
import { getLinkedServices } from "../services/linkedService";

interface IuseFetchLinkedServices {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  sub_type?: string;
  system_type?: number;
}
const useFetchLinkedServices = ({
  setIsLoading,
  sub_type,
  system_type,
}: IuseFetchLinkedServices) => {
  const [linkedServicesData, setLinkedServicesData] = useState<any[]>([]);
  useEffect(() => {
    setIsLoading(true);
    const getLinkedServicesData = async () => {
      try {
        const result = await getLinkedServices(sub_type, system_type);
        const res = result && Array.isArray(result) ? result.reverse() : [];
        setLinkedServicesData(res);
      } catch (err) {
        setLinkedServicesData([]);
      } finally {
        setIsLoading(false);
      }
    };
    getLinkedServicesData();
  }, [sub_type, system_type]); // Added dependencies to re-fetch when these values change

  return [linkedServicesData];
};

export default useFetchLinkedServices;
